<template>
  <div class="select-bar-wrapper">
    <div v-if="selectBarSetting" :class="`select-bar ${selectedStatus === '' ? '' : 'selected-bar'}`">
      <!--地区选择-->
      <div :class="`select-area-bar ${selectedStatus === 'area' ? 'selected-item-bar' : ''}`" @click="changeStatus('area')">
        <span class="name">{{ selectedCity.value || selectBarSetting.citySearch.text }}</span>
        <span class="icon"></span>
      </div>
      <!--区域选择-->
      <div v-if="selectBarSetting.regionalSubway?.checkRegion || selectBarSetting.regionalSubway?.checkSubway" :class="`select-area-bar ${selectedStatus === 'district' ? 'selected-item-bar' : ''}`" @click="changeStatus('district')">
        <span class="name regionalSubway">{{ districtText }}</span>
        <span class="icon"></span>
      </div>
      <!--更多选择-->
      <div
        v-if="selectBarSetting.moreSearch?.check || moreOptions.length > 0"
        :class="`select-more-bar ${selectedStatus === 'more' ? 'selected-item-bar' : ''}`"
        @click="changeStatus('more')"
      >
        <span class="name">{{ selectBarSetting.moreSearch.text }}</span>
        <span class="icon"></span>
      </div>
    </div>
    <!--列表-->
    <div class="select-list-wrapper" v-if="selectedStatus">
      <div class="select-area-content p-20-30" v-if="selectedStatus === 'area'">
        <span
          :class="`city-item ${selectedCity === item ? 'city-item-selected' : ''}`"
          v-for="(item, index) in cityList"
          :key="index"
          @click="selectCityBtn(item)"
          >{{ item.value }}</span
        >
      </div>
      <div class="select-area-content" v-if="selectedStatus === 'district' || selectedStatus === 'station'">
        <DistrictStationSelect
          :type="districtSelectType"
          :list="districtArr"
          :lines="lines"
          :activityId="activityId"
          :currentType="currentType"
          :selectedDistrict="selectedDistrict"
          :selectedLine="selectedLine"
          @selectDistrict="selectDistrictBtn"
          @selectLine="selectLineBtn"
          @reset="resetDistrictStation"
        />
      </div>
      <div v-if="selectedStatus === 'more'">
        <div class="select-more-content p-20-30">
          <div class="more-item" v-for="(item, index) in moreOptions" :key="index">
            <p class="more-item-title">{{ item.name }}</p>
            <div class="more-item-options">
              <span
                :class="`option ${item.selected.includes(option.uid) ? 'option-selected' : ''}`"
                v-for="(option, _index) in item.children"
                :key="_index"
                @click="selectMoreBtn(option, item)"
                >{{ option.name }}</span
              >
            </div>
          </div>
        </div>
        <div class="select-btns-wrapper">
          <span class="cancel-btn btn" @click="moreSelectCancel">取消</span>
          <span class="separate"></span>
          <span class="ensure-btn btn" @click="moreSelectEnsure">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { cityList } from './constant'
import { buryingPoint } from '@/utils/buryingPoint'
import { getStoreRegionByCity, getStoreSubwayByCity } from '@/server/interfaces'
import DistrictStationSelect from '../DistrictStationSelect'
import { stationLines } from '@/server/station'
export default {
  components: {
    DistrictStationSelect
  },
  props: {
    activityInfo: {
      type: Object,
      default: () => {}
    },
    handleSelectCity: {
      type: Function,
      default: () => {}
    },
    handleSelectMore: {
      type: Function,
      default: () => {}
    },
    handleSelectDistrict: {
      type: Function,
      default: () => {}
    },
    handleSelectLine: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      selectedStatus: '', // area, more
      cityList: cityList,
      districtArr: [], // 区域
      lines: [], // 地铁线
      currentType: 'district' // district line
    }
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId',
      selectCategorieUid: 'home/selectCategorieUid',
      selectedCity: 'home/selectedCity',
      moreOptionsId: 'home/moreOptionsId',
      selectedLine: 'home/selectedLine',
      selectedDistrict: 'home/selectedDistrict'
    }),
    districtText () {
      const current = this.currentType === 'district' ? this.selectedDistrict.name : this.selectedLine.line
      return current === '不限' ? this.selectBarSetting.regionalSubway?.text : current
    },
    moreOptions () {
      let result = []
      this.activityInfo.mapStyle?.categories
        .filter(item => this.selectCategorieUid.includes(item.uid))
        .filter(item => item.status === true)
        .filter(item => item.children?.length > 0)
        .forEach(item => {
          result = result.concat(
            item.children.map(_item => {
              !_item.children && (_item.children = [])
              const _selectedArr = _item.children.filter(_item => this.moreOptionsId.includes(_item.uid)).map(item => item.uid)
              _item.selected = !_selectedArr.length ? [''] : _selectedArr
              console.log(_item)
              if ((_item.children[0] && _item.children[0].name !== '全部') || !_item.children?.length) {
                _item.children.unshift({
                  uid: '',
                  name: '全部',
                  status: true
                })
              }
              return _item
            })
          )
        })
      console.log('看看moreOptions的数据结构：', result)
      return result
    },
    selectBarSetting () {
      return this.activityInfo.mapStyle?.fnModule
    },
    districtSelectType () {
      const { regionalSubway } = this.selectBarSetting
      // 配置区域和地铁 则在区域下拉框一起显示
      if (regionalSubway.checkRegion && regionalSubway.checkSubway) {
        return 'all'
      } else if (regionalSubway.checkRegion) {
        return 'district'
      } else {
        return 'station'
      }
    }
  },
  methods: {
    ...mapMutations({
      setSelectedCity: 'home/setSelectedCity',
      setSelectedDistrict: 'home/setSelectedDistrict',
      setSelectedLine: 'home/setSelectedLine',
      setMoreOptionsIdByArr: 'home/setMoreOptionsIdByArr'
    }),
    recoveryDate () {
      this.selectedStatus = ''
    },
    changeStatus (status) {
      const action = { area: 2, more: 6, district: 36 }[status]
      action && buryingPoint({ action, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      if (status === this.selectedStatus) {
        this.selectedStatus = ''
        return
      }
      this.selectedStatus = status
    },
    // 筛选城市
    selectCityBtn (item) {
      this.setSelectedDistrict({ name: '不限' })
      this.setSelectedLine({ line: '不限' })
      buryingPoint({ action: 4, sourceTag: 2, activityId: this.activityId, optionName: item.value, itemType: 2 })
      this.setSelectedCity(item)
      this.selectedStatus = '' // 收起
      this.handleSelectCity(item)
      // 非全省
      if (item.code !== '440000') {
        this.updateDistrictArr(item)
      } else {
        this.lines = []
        this.districtArr = []
      }
    },
    // 筛选区域
    selectDistrictBtn (item) {
      this.currentType = 'district'
      this.setSelectedLine({ line: '不限' })
      this.setSelectedDistrict(item)
      this.handleSelectDistrict(item)
      this.selectedStatus = '' // 收起
    },
    // 筛选地铁线
    selectLineBtn (item) {
      this.currentType = 'line'
      this.setSelectedDistrict({ name: '不限' })
      this.setSelectedLine(item)
      this.handleSelectLine(item)
      this.selectedStatus = '' // 收起
    },
    resetDistrictStation () {
      this.currentType = 'district'
      this.selectedStatus = '' // 收起
      if (this.selectedDistrict.name === '不限' && this.selectedLine.line === '不限') return
      this.setSelectedLine({ line: '不限' })
      this.setSelectedDistrict({ name: '不限' })
      // 回到城市
      this.setSelectedCity(this.selectedCity)
      this.handleSelectCity(this.selectedCity)
    },
    async updateDistrictArr (item) {
      const regionalSubway = this.selectBarSetting.regionalSubway
      const params = {
        activityId: this.activityId,
        cityCode: item.code
      }
      // 有信息点的区域列表
      if (regionalSubway?.checkRegion) {
        const res = await getStoreRegionByCity(params)
        if (res.code === 200) {
          this.districtArr = res.data.map(i => ({ name: i.district, districtid: i.zipcode }))
        }
      }
      // 有信息点的地铁线路列表
      if (regionalSubway?.checkSubway) {
        const lineRes = await getStoreSubwayByCity(params)
        if (lineRes.code === 200) {
          const fullLines = stationLines[item.value] || []
          this.lines = fullLines.filter(l => lineRes.data.find(i => i.belongSubway === l.line))
        }
      }
    },
    moreSelectCancel () {
      // console.log("moreSelectCancel")
      buryingPoint({ action: 8, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      this.recoveryDate()
    },
    moreSelectEnsure () {
      buryingPoint({ action: 9, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      const ids = this.moreOptions.reduce((acc, cur) => acc.concat(cur.selected.filter(item => item !== '')), [])
      this.setMoreOptionsIdByArr(ids)
      this.handleSelectMore(ids)
      this.recoveryDate()
    },
    selectMoreBtn (option, item) {
      // 需求大佬说多选变单选
      // if (item.selected.includes(option.uid)) {
      //   item.selected = item.selected.filter(item => item !== option.uid)
      // } else {
      //   item.selected.push(option.uid)
      // }
      buryingPoint({ action: 7, sourceTag: 2, activityId: this.activityId, optionName: option.name, itemType: 2 })
      item.selected = [option.uid]
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.p-20-30 {
  padding: 0.3rem 0.2rem;
}
div,
span,
p {
  font-size: 0.28rem;
}
.select-bar {
  position: fixed;
  top: 1.86rem;
  left: 0.2rem;
  z-index: 1000;
  width: calc(100% - 0.4rem);
  height: 0.76rem;
  display: flex;
  justify-self: center;
  align-items: center;
  font-size: 0.28rem;
  border-radius: 0.38rem;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(113, 108, 98, 0.2);
  .icon {
    display: inline-block;
    width: 0.22rem;
    height: 0.12rem;
    margin-left: 0.05rem;
    background: url(../../../../assets/images/icon_down.png) no-repeat center;
    background-size: 0.22rem;
    transform: translateY(-0.02rem);
  }
  .select-area-bar {
    flex: 1;
    text-align: center;
    .name {
      margin-right: 0.01rem;
    }
    .regionalSubway {
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 80%;
      vertical-align: top;
    }
  }
  .select-more-bar {
    flex: 1;
    text-align: center;
    .name {
      margin-right: 0.01rem;
    }
  }
  .selected-item-bar {
    color: #ca1b22;
    .icon {
      background: url(../../../../assets/images/icon_down_red.png) no-repeat center;
      background-size: 0.2rem;
    }
  }
}
.selected-bar {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  box-shadow: none;
}
.select-list-wrapper {
  width: calc(100% - 0.4rem);
  height: 5.2rem;
  position: fixed;
  left: 0.2rem;
  top: 2.62rem;
  z-index: 91;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(113, 108, 98, 0.2);
  border-bottom-right-radius: 0.38rem;
  border-bottom-left-radius: 0.38rem;
  border-top: 1px solid #eee;
  overflow-x: hidden;
  max-height: 60%;
  overflow-y: auto;
  .select-area-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    // justify-content: space-between;
    .city-item {
      display: inline-block;
      width: 1.52rem;
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: center;
      color: #666666;
      font-size: 0.28rem;
      border-radius: 0.36rem;
      border: 1px solid #ccc;
      margin: 0 0.2rem 0.2rem 0;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
    .city-item-selected {
      color: #ca1b22;
      border: 1px solid #c41b1b;
    }
  }
  .select-more-content {
    width: 100%;
    height: 4.18rem;
    overflow-y: scroll;
    font-size: 0.28rem;
    .more-item-title {
      color: #999;
      margin-bottom: 0.1rem;
    }
    .more-item-options {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 0.4rem;
      flex-wrap: wrap;
      .option {
        text-align: center;
        width: 1.47rem;
        height: 0.6rem;
        line-height: 0.6rem;
        border: 1px solid #cccccc;
        margin-right: 0.2rem;
        margin-top: 0.2rem;
        border-radius: 0.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .option-selected {
        color: #ca1b22;
        border: 1px solid #c41b1b;
      }
    }
  }
  .select-btns-wrapper {
    width: 100%;
    height: 1rem;
    border-top: 1px solid #eee;
    display: flex;
    align-items: center;
    .btn {
      flex: 1;
      text-align: center;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.32rem;
    }
    .cancle-btn {
      color: #666;
    }
    .ensure-btn {
      color: #ca1b22;
    }
    .separate {
      display: inline-block;
      background: #d8d8d8;
      width: 1px;
      height: 0.4rem;
      line-height: 1rem;
    }
  }
}
</style>
